import {
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_ADMINS,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_LANDLORDS,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_MANAGER,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_TENANTS,
} from '../../DocumentFolderForm.constants'

export const ACCESS_FIELD_NAMES = {
  admins: `${DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS}.${DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_ADMINS}`,
  landlords: `${DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS}.${DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_LANDLORDS}`,
  managers: `${DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS}.${DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_MANAGER}`,
  tenants: `${DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS}.${DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_TENANTS}`,
}
